import reducerConstant from 'common/reducerConstants';

const initialState = {
  userData: {
    accessToken: null,
    id: null,
    media: null,
    firstName: null,
    lastName: null,
    email: null,
    countryCode: null,
    mobileNumber: null,
  },
  error: null,
  getProfileTs: null,
  updateStatus: false,
  updateError: null,
  updateProfileTs: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case reducerConstant.profileSuccess:
      return {
        ...state,
        userData: action.payload.response,
        getProfileTs: Date.now(),
        error: '',
      };
    case reducerConstant.profileFailed:
      return {
        ...state,
        error: action.payload.message,
        getProfileTs: Date.now(),
      };
    case reducerConstant.updateProfileSuccess:
      return {
        ...state,
        updateStatus: true,
        userData: action.payload.response,
        updateProfileTs: Date.now(),
        updateError: null,
      };
    case reducerConstant.updateProfileFailed:
      const obj = {
        email:
          (action.payload.errors &&
            action.payload.errors.email &&
            action.payload.errors.email[0]) ||
          null,
        mobileNumber:
          (action.payload.errors &&
            action.payload.errors.mobileNumber &&
            action.payload.errors.mobileNumber[0]) ||
          null,
        firstName:
          (action.payload.errors &&
            action.payload.errors.firstName &&
            action.payload.errors.firstName[0]) ||
          null,
        lastName:
          (action.payload.errors &&
            action.payload.errors.lastName &&
            action.payload.errors.lastName[0]) ||
          null,
      };
      return {
        ...state,
        updateError: obj,
        updateStatus: false,
        updateProfileTs: Date.now(),
      };
    case reducerConstant.generateSignedUrlError:
      const urlObj = {
        sourceDisk:
          (action.payload.errors &&
            action.payload.errors.sourceDisk &&
            action.payload.errors.sourceDisk[0]) ||
          null,
        mimeType:
          (action.payload.errors &&
            action.payload.errors.mimeType &&
            action.payload.errors.mimeType[0]) ||
          null,
        objType:
          (action.payload.errors &&
            action.payload.errors.objType &&
            action.payload.errors.objType[0]) ||
          null,
      };
      return {
        ...state,
        updateError: urlObj,
        updateStatus: false,
        updateProfileTs: Date.now(),
      };
    case reducerConstant.profileReset:
      return {
        ...state,
        updateStatus: false,
      };

    case 'persist/REHYDRATE':
      return action.payload ? action.payload.profileReducer : state;

    default:
      return state;
  }
};
export default profileReducer;
